function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.57633 13.54717h-.54202l-.19211-.18525c.67238-.78216 1.07718-1.7976 1.07718-2.90223C14.91938 7.99657 12.92281 6 10.4597 6S6 7.99657 6 10.4597c0 2.46311 1.99657 4.45968 4.4597 4.45968 1.10462 0 2.12006-.4048 2.90222-1.07718l.18525.1921v.54203L16.9777 18 18 16.9777l-3.42367-3.43053zm-4.11664 0c-1.7084 0-3.08748-1.37907-3.08748-3.08748 0-1.7084 1.37908-3.08748 3.08748-3.08748 1.7084 0 3.08748 1.37908 3.08748 3.08748 0 1.7084-1.37907 3.08748-3.08748 3.08748z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgSearchCopy1 = function SvgSearchCopy1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearchCopy1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search Copy 1.9515e97b.svg";
export { ForwardRef as ReactComponent };